import styled from '@emotion/styled'
import {theme} from '../../core/theme'

export const Wrapper = styled.div`
  background: ${theme.colors.bg.primary};
  padding: ${theme.space[4]};
  box-shadow: ${theme.shadows.sm};
  margin-bottom: ${({flushEdges}) => (flushEdges ? 0 : '-24px')};
  margin-right: ${({flushEdges}) => (flushEdges ? 0 : '-24px')};

  flex: 0 0 25%;
  align-self: stretch;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: inherit;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const HeaderLeft = styled.div`
  h2 {
    font-size: ${theme.fontSizes.xl};
    font-weight: ${theme.fontWeights.bold};
  }
  p {
    font-size: ${theme.fontSizes.md};
    margin-top: 2px;
  }
`

export const HeaderRight = styled.div`
  text-align: right;
  .total {
    font-size: ${theme.fontSizes.xl};
    font-weight: ${theme.fontWeights.bold};
  }
  .note {
    font-size: ${theme.fontSizes.xxs};
    margin-top: 2px;
  }
`

export const SectionBlock = styled.div`
  border-radius: ${theme.radii.md};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1.25]};
`

export const ItemRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${theme.space[2.5]};
  padding: ${theme.space[2.5]};
  border-radius: ${theme.radii.lg2};
  background: ${theme.colors.bg.primary};
  ${({selected}) =>
    selected &&
    `
    background: ${theme.colors.bg.warningLight};
    border: 1.5px solid ${theme.colors.border.brand};
    border-radius: 6px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 25px;
      background: ${theme.colors.border.brand};
      border-radius: 0 10px 10px 0;
    }
  `}
`

export const ItemIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
`

export const ItemInfo = styled.div`
  flex: 1;
`

export const ItemName = styled.div`
  font-size: ${theme.fontSizes.sm};
  ${({selected}) => selected && `font-weight: ${theme.fontWeights.bold};`}
`

export const ItemSub = styled.div`
  font-size: 11px;
  color: ${theme.colors.text.subtle};
`

export const ItemPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
`

export const ItemPrice = styled.div`
  font-size: ${theme.fontSizes.sm};
`

export const ItemDiscount = styled.div`
  font-size: 11px;
  color: #22c55e;
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: ${theme.space[0.5]};
  gap: 2px;
  padding: 40px 0;
  p {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.bold};
    margin: 0;
  }
  span {
    font-size: ${theme.fontSizes.xxs};
  }
`

export const LocationAccordion = styled.div`
  border-radius: ${theme.radii.lg2};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1.25]};
`

export const LocationAccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${theme.space[2]};
  background: ${theme.colors.bg.infoLight};
  padding: ${theme.space[1.25]};
  gap: ${theme.space[1.25]};
`

export const LocationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  font-size: ${theme.fontSizes.sm};

  .pin {
    margin-right: 6px;
  }
  .loc-name,
  .loc-total {
    font-weight: ${theme.fontWeights.bold};
  }
  .loc-total {
    display: flex;
    align-items: center;
    gap: ${theme.space[1.25]};
  }
`

export const LocationMeta = styled.div`
  display: flex;
  align-items: center;
`

export const SubAccordion = styled.div`
  background: ${theme.colors.bg.blueSubtleBg};
  border-radius: ${theme.radii.lg2};
  padding: ${theme.space[2.5]};
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1.25]};
`

export const SubAccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${theme.space[2.5]};
  cursor: pointer;
  gap: ${theme.space[1.25]};
`

export const SubAccordionMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[1]};

  .sub-category {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.bold};

    span {
      font-weight: ${theme.fontWeights.regular};
    }
  }
`

export const SubAccordionTotal = styled.div`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
`

export const ChevronIcon = styled.span`
  font-size: 10px;
  display: inline-flex;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  transform: ${({open}) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
  margin-left: 6px;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const FooterRow = styled.div`
  display: flex;
  white-space: nowrap;
  gap: 8px;
  padding-top: 8px;
`

export const ItemSubRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
`

export const ItemDetailsToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.text.link};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover {
    color: ${theme.colors.text.linkHover};
  }
`

export const ItemDetailsPanel = styled.div`
  background: ${theme.colors.bg.primary};
  border-radius: ${theme.radii.md};
  margin: -4px ${theme.space[2.5]} 0;
  padding: ${theme.space[2]} ${theme.space[2.5]};
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1]};
`

export const ItemDetailRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${theme.space[2]};
`

export const ItemDetailLabel = styled.div`
  // flex: 0 0 90px;
  font-size: 11px;
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.primary};
`

export const ItemDetailValue = styled.div`
  // flex: 1;
  font-size: 11px;
  color: ${theme.colors.text.primary};
  word-break: break-all;
`

export const ItemDetailAddonsHeading = styled.p`
  margin: ${theme.space[1]} 0 0;
  font-size: 10px;
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  ${({noDivider}) =>
    noDivider
      ? 'margin-top: 0;'
      : `
    border-top: 1px solid ${theme.colors.border.subtle};
    padding-top: ${theme.space[1.5]};
  `}
`

export const GstDisclaimer = styled.p`
  font-size: clamp(11px, 1.2vw, 13px);
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  margin: ${theme.space[1.25]} 0 0;
`

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 1;
  }
`
